import React, { useState } from "react";
import { connect } from "react-redux";
import { Button, ButtonToolbar, Col, Modal, ModalBody, Row } from "reactstrap";
import PropTypes from 'prop-types';
import PndRestApi from "src/utils/pnd/PndRestApi";
import { showNotification, successNofication } from "src/shared/components/Notification";
import { useEffect } from "react";
import { Field, change, reduxForm } from "redux-form";
import { Redirect } from "react-router-dom";
import { ERROR_MESSAGES, PAGE_TIMEOUT } from "src/utils/pnd/PndConstants";

const required = value => value ? undefined : 'Required'

const renderField = ({ input, label, placeholder, type, meta: { touched, error, warning }, disabled }) => (
    <div className="form__form-group">
        <div className="form__form-group">
            <input
                {...input}
                  className="custom-placeholder"
                placeholder={placeholder}
                type={type}
                disabled={disabled}  // Add the disabled prop here
            />
            {touched && ((error && <span className="form__form-group-error"> {label} {error}</span>) || (warning && <span>{warning}</span>))}
        </div>
    </div>
);
const DutyExtensionModal = ({ modalShow, setModalShow, isTitle, isRiderRequestedHr, dispatch, dataInfo }) => {
    const [isRedirect, setIsRedirect] = useState(false);
    const [isHubApprovedHr, setHubApprovedHr] = useState(null);
    let Icon;

    const toggle = () => {
        setModalShow(prevState => !prevState)
    }
    useEffect(() => {
        dispatch(change('DutyExtensionModalForm', 'hubApprovedHr', isRiderRequestedHr));

    }, [])

  

    const handleSubmit = async () => {
        try {
            let obj = {};
            let approvedHr = isHubApprovedHr ? isHubApprovedHr : isRiderRequestedHr; // Get hubApprovedHr value from props
            if (!/^\d{1,2}:\d{2}$/.test(approvedHr)) {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: 500`,
                    `Message:Invalid time format. Please enter in HH:mm format.`,
                );
                return;

            }
            // If minutes are missing in the input, append ':00'
            if (approvedHr && !approvedHr.includes(":")) {
                approvedHr += ":00";
            } else {
                const [hours, minutes] = approvedHr.split(':').map(Number);

                // Calculate total milliseconds
                const totalMilliseconds = (hours * 60 * 60 * 1000) + (minutes * 60 * 1000);
                obj["extendedTime"] = totalMilliseconds;
            }


            obj["roasterId"] = dataInfo?.roasterId;

            // Call API with adjusted hubApprovedHr value
            const response = await PndRestApi.RiderDutyExtensionApproval(obj);

            if (response.status === 200 && response.data.status === 200) {
                successNofication(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    ERROR_MESSAGES.successMessage,
                );
                setTimeout(() => {
                    setIsRedirect(true);
                  }, PAGE_TIMEOUT);
            } else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message:${response.data.message}`,
                );
            }
        } catch (error) {
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: 500`,
                ERROR_MESSAGES.tryCatchError,
            );
        }
    };


if(isRedirect){
    window.location.reload();
        return <Redirect to=" /web_app/rider/duty_roaster/view" />;
   
}
const back = () => {
    setIsRedirect(true);
}
    return (
        <div >
            <Modal
                isOpen={modalShow}
                toggle={toggle}
                modalClassName={`ltr-support`}
                className="theme-light ltr-support credit-memo-modal-form-ani">
                <div className="modal__header">
                    <button
                        className="lnr lnr-cross modal__close-btn"
                        aria-label="modal__close-btn"
                        type="button"
                        onClick={toggle}
                    />
                    {Icon}
                    <h4
                        className="text-modal  modal__title mt-1 text-uppercase"

                    >
                        {isTitle}
                    </h4>
                 
                </div>
                {/* <div>  <Fab size="large" color="primary" aria-label="add" style={{ float: "right" }} onClick={() => back()}>
                    <ArrowBackIcon />
                </Fab></div> */}
                <ModalBody className="m-0">
                    <div className="credit-memo-modal-form-ani">
                        {/* <span className="account__logo">
                            <span
                                className="account__logo-accent text-light"> */}
                                <form className="form-animated">
                                    <Col lg={12} md={12}>
                                        <Row>
                                            <Col lg={12} md={12}>
                                                <div className="form__form-group">
                                                    <span className="form__form-group-label">Rider Requested Hours(HH:MM)</span>
                                                    <div className="form__form-group-field">
                                                        <input name="riderRequestedHr" component={renderField} type="text" placeholder="Rider Requested Hours" disabled={true} value={isRiderRequestedHr} />
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg={12} md={12}>
                                                <div className="form__form-group">
                                                    <span className="form__form-group-label">Hub Approved Hours (HH:MM)</span>
                                                    <div className="form__form-group-field">
                                                        <Field name="hubApprovedHr" component={renderField} type="text" placeholder="Hub Approved Hours" validate={[required]} onChange={(e) => setHubApprovedHr(e.target.value)} />
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg={12} md={12}>
                                                <div className="form__OnboardingButton">
                                                    <ButtonToolbar className="form__button-toolbar wizard__toolbar">
                                                        <Button color="primary"  className="next" onClick={handleSubmit}>Approve</Button>
                                                    </ButtonToolbar>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </form>
                            {/* </span>
                        </span> */}
                    </div>
                </ModalBody>
            </Modal>
        </div>
    );
};
DutyExtensionModal.propTypes = {
    DutyExtensionModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {

};

export default connect(mapStateToProps)(reduxForm({ form: 'DutyExtensionModalForm', enableReinitialize: true })(DutyExtensionModal));
